import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from '../../../iba-components/Button'
import { showPopBanner } from '../../../iba-components/PopBanner'
import LoadingMask from '../../components/LoadingMask'
import { wait } from '../../utils'
import { updateUser } from '../../actions/userInfo'
import { verifyChangeEmail, logout } from '../../api/commonV2'
import './verify.css'

// Note: IDパスワードログインユーザーのメールアドレス変更時、ProductIAMで送信されるメールから遷移してくるページ
export const Verify = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const userInfo = useSelector((state) => state.userInfo)
    const urlParams = Object.fromEntries(new URLSearchParams(location.search))
    const { verificationToken, verificationId } = urlParams
    const history = useHistory()
    const { t } = useTranslation()
    const [changeable, setChangeable] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')

    const redirectToLogin = async () => {
        const isLogin = userInfo.hasError === false
        if (!isLogin) {
            window.sessionStorage.setItem('notUpdate', true)
            dispatch(updateUser({}))
            const redirect_uri = window.location.origin + '/loginiam'
            const { logout_url } = await logout({ redirect_uri })
            const url = logout_url ? decodeURIComponent(logout_url) : redirect_uri
            window.location.href = url
        } else {
            history.replace('/loginiam')
        }
    }

    const verifyEmail = async () => {
        setLoading(true)
        setChangeable(false)
        showPopBanner({
            message: t('verify.inProgress'),
            status: 'success',
            duration: 3000
        })
        const { hasError, desc } = await verifyChangeEmail({
            verificationToken,
            verificationId
        })
        setLoading(false)
        if (hasError) {
            showPopBanner({
                message: desc,
                status: 'error',
                duration: 3000
            })
            setErrorMsg(desc)
        } else {
            showPopBanner({
                message: t('verify.successChangeEmail'),
                status: 'success',
                duration: 10000
            })
            await wait(10000)
            redirectToLogin()
        }
    }

    useEffect(() => {
        if (!verificationToken || !verificationId) {
            setErrorMsg(t('verify.noParamsError'))
            showPopBanner({
                message: t('verify.noParamsError'),
                status: 'error',
                duration: 10000
            })
            return
        }
        verifyEmail()
    }, [])

    return (
        <>
            {loading && <LoadingMask />}
            <div className="a-verify-middle-part verify-div">
                <div className="logo flex-center">
                    <div className="a-login-logo a-pwc-theme-adapt-logon" />
                </div>
                <h4 className="flex-center">{t('verify.title')}</h4>
                {errorMsg && <div className="a-verify-error-info mt-10"> {errorMsg} </div>}
                <div className="btn-with-loading flex-center submitBtn">
                    <Button
                        size="xl"
                        width="104px"
                        label={t('verify.loginPage')}
                        disabled={!changeable}
                        onClick={redirectToLogin}
                    />
                </div>
            </div>
        </>
    )
}
